import React from 'react';

import { Box, Group, Skeleton } from '@mantine/core';

export function UserButtonLoadingSkeleton() {
  return (
    <Group>
      <Skeleton height={40} circle />
      <Box style={{ flex: 1 }}>
        <Skeleton height={8} radius="xs" />
        <Skeleton height={8} mt={6} radius="xs" />
      </Box>
    </Group>
  );
}
